import React, { useState, useRef } from 'react';
import styled from 'styled-components';
import { UserDomain } from '@pomofocus/core';
import { ButtonText } from '../styles/Button';
import { OrLine } from '../common/OrLine';
import { AccountForm, ErrorMessageStyle, FormCardStyle, LabelStyle, SwitchPage, } from './LoginFormStyles';
import AccountFormShell from './AccountFormShell';
import GoogleLoginButton from './GoogleLoginButton';
import { KEY_ENTER } from '../../constants';
import { Button } from '../common/Button';
export default function LoginForm({ handleClickForgotPass, handleClickGoogle, submit, displayErrorMessage, errorMessage, handleClickSwitch, loginWithAuthCode, isElectron, activities, }) {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const emailRef = useRef(null);
    const passwordRef = useRef(null);
    const checkError = () => {
        if (!UserDomain.validateEmail(email))
            return 'Please input valid email';
        if (!UserDomain.validatePassword(password)) {
            return 'Password must contain least 8 characters';
        }
    };
    const _handleClickGoogle = (code) => {
        handleClickGoogle(code, activities);
    };
    const handleClickSubmit = () => {
        const _errorMessage = checkError();
        if (_errorMessage) {
            displayErrorMessage(_errorMessage);
        }
        else {
            submit(email, password);
        }
    };
    const handleKeyDownEmail = (e) => {
        if (!passwordRef.current)
            return;
        passwordRef.current.focus();
    };
    const handleKeyDownPassword = (e) => {
        if (e.key === KEY_ENTER) {
            handleClickSubmit();
        }
    };
    // useEffect(() => {
    //   window.alert(
    //     'Google Login is currently having an issue and it may take sometime to login. However, you can wait a little longer and it sometimes work. If not, please switch to the email login by hitting "Forgot Password" and setting a new password.',
    //   );
    // }, [null]);
    return (React.createElement(AccountFormShell, { title: "Login" },
        React.createElement(FormCard, null,
            React.createElement(GoogleLoginWrapper, null,
                React.createElement(GoogleLoginButton, { handleClickGoogle: _handleClickGoogle, loginWithAuthCode: loginWithAuthCode, isElectron: isElectron, title: "Login with Google" })),
            React.createElement(OrLine, null),
            React.createElement(Label, null, "Email"),
            React.createElement(Form, { value: email, placeholder: "example@mail.com", onChange: (e) => setEmail(e.target.value), onKeyDown: handleKeyDownEmail }),
            React.createElement(Label, null, "Password"),
            React.createElement(Form, { type: "password", value: password, onChange: (e) => setPassword(e.target.value), onKeyDown: handleKeyDownPassword }),
            errorMessage && React.createElement(ErrorMessage, null, errorMessage),
            React.createElement(ButtonWrapper, null,
                React.createElement(Button, { onClick: handleClickSubmit, theme: "primary", size: "large", fullWidth: true }, "Log in with Email")),
            React.createElement(ForgotPasswordWrapper, null,
                React.createElement(ButtonText, { onClick: handleClickForgotPass, styles: { width: '100%', marginTop: '16px' } }, "Forgot Password"))),
        React.createElement(SwitchWrapper, null,
            React.createElement(SwitchText, null, "Do not have an account?"),
            React.createElement(ButtonText, { styles: { fontSize: '17px' }, onClick: handleClickSwitch }, "Create account"))));
}
const FormCard = styled.div `
  ${FormCardStyle}
`;
const GoogleLoginWrapper = styled.div `
  margin-top: 18px;
`;
const Label = styled.div `
  ${LabelStyle}
`;
const SwitchWrapper = styled.div `
  ${SwitchPage}
`;
const SwitchText = styled.div `
  margin-bottom: 8px;
`;
const ErrorMessage = styled.p `
  ${ErrorMessageStyle}
`;
const ButtonWrapper = styled.div `
  margin-top: 28px;
`;
const Form = styled.input `
  ${AccountForm}
`;
const ForgotPasswordWrapper = styled.div `
  display: flex;
  justify-content: center;
  margin-top: 20px;
`;
